// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-product-more-details-link-link-bygih{align-items:center;background:var(--color-accent2);border:none;border-radius:12px;color:var(--color-primary);cursor:pointer;display:flex;font-size:14px;font-weight:500;height:44px;justify-content:center;letter-spacing:.075em;min-width:64px;outline:none;padding:0;text-decoration:none}.components-products-product-more-details-link-link-bygih:hover{background:var(--color-accent2-hover)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "components-products-product-more-details-link-link-bygih"
};
module.exports = ___CSS_LOADER_EXPORT___;
